import { Img } from "container/Manual/components/content/Image";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { ScrollLink } from "container/Manual/components/content/ScrollLink";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const SUBSTITUTE = () => {
  return (
    <CardSection id="SUBSTITUTE" title="SUBSTITUTE">
      <Paragraph>
        텍스트 문자열에서 기존 텍스트를 새 텍스트로 대체합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>SUBSTITUTE(VALUE, OLD TEXT, NEW TEXT)</Paragraph>
        <Ul>
          <Li>
            <b>VALUE</b>는 문자를 대체하려는 텍스트 또는 열입니다.
          </Li>
          <Li>
            <b>OLD TEXT</b>는 바꾸고 싶은 텍스트입니다. 대소문자를 구분합니다.
          </Li>
          <Li>
            <b>NEW TEXT</b>는 <b>OLD TEXT</b>를 대체하는 데 사용할 텍스트입니다.
            대소문자를 구분합니다.
          </Li>
        </Ul>
      </ListSection>

      {/* <ListSection title="Example">
    <Paragraph accent>SUBSTITUTE(`Hospital Name`, "CREIGHTON", "Merton")</Paragraph>
    <Img src="computeLeft" />
  </ListSection> */}

      <ListSection title="Notes on use">
        <Paragraph>
          텍스트 문자열에서 특정 텍스트를 바꾸려면 <b>SUBSTITUTE</b>를
          사용하세요. 텍스트 문자열의 특정 위치에 있는 모든 텍스트를 바꾸려는
          경우 <ScrollLink label="REPLACE" targetId="REPLACE" isSmooth /> 섹션을
          참조하세요.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
